import React from "react";

export const clickOutside = (evt, ref, setOpen, newValue) => {
  if (!ref.current?.contains(evt.target)) {
      setOpen(newValue || false);
      return;
  }
}
